import {useMutation, useQuery} from "react-query"
import axios from "axios"
import {useState} from "react";
import {queryClient} from "../App";
import {flattenConfigObject} from "../DataFunctions";
const auth = window.location.hostname === "localhost" ? {auth: {username: 'DevAnnie', password: 'JLdlVR1cTvUuRrjpNxwg'}} : null

export function AuthCheck() {
    return useQuery("auth", async () => {
        const { data } = await axios.post(
            "/api/v2/auth.php",
            {
                "ReturnTo":window.location.href
            }
        )
        return data
    }, {
        retry: false
    })
}

export function GetSurveys(status) {
    const statusQuery = status ? "?status="+status : ""
    return useQuery("surveys"+statusQuery, async () => {
        const { data } = await axios.get(
            "/api/v2/survey.php"+statusQuery,
            auth
        )
        return data
    })
}

export function GetSurveyWithId(surveyId) {
    // TODO: Check caching. Currently not updated when editing
    return useQuery('survey'+surveyId, async () => {
        const { data } = await axios.get(
            "/api/v2/survey.php/"+surveyId,
            auth
        )
        return data
    })
}

export function UpdateSurveyWithId(surveyId) {
    return useMutation('survey'+surveyId, surveyData => {
        const data = axios.post(
            "/api/v2/survey.php/" + surveyId,
            surveyData,
            auth
        )
        return data
    })
}

export function UpdateSurveyWithIdAndUpdateContext(surveyId, setSurveyData, setOriginalSurveyData) {
    return useMutation('survey' + surveyId, surveyData => {
        return axios.post("/api/v2/survey.php/" + surveyId, surveyData, auth)
    }, {
        onSuccess: () => {
            // Fetch the latest survey data
            axios.get("/api/v2/survey.php/" + surveyId, auth)
                .then(response => {
                    // Update the context with the fetched data
                    const data = response?.data[0]
                    if (data) {
                        const flattenedData = flattenConfigObject(data)
                        setSurveyData(flattenedData)
                        setOriginalSurveyData(flattenedData)
                    }
                });
        }
    })
}

export function PostSurveyWithId(surveyId) {
    return useMutation('survey'+surveyId,surveyData => {
        const data = axios.post(
            "/api/v2/survey.php/" + surveyId,
            surveyData,
            auth
        )
        return data
    })
}

export function GetSupportNeeds() {
    return useQuery("supportneeds", async () => {
            const { data } = await axios.get(
            window.location.hostname === "localhost" ? window.location.origin+"/admin/mock-api/supportneed.json" : "/api/v2/supportneed.php/"
        )
        return data
    })
}

export function GetUsers() {
    return useQuery("annieuser", async () => {
        const { data } = await axios.get(
            "/api/v2/annieuser.php/",
            auth
        )
        return data
    })
}

export function GetUser(user) {
    return useQuery("user", async () => {
        const { data } = await axios.get(
            "/api/v2/annieuser.php/"+user,
            auth
        )
        return data
    })
}

export function GetUserSurvey() {
    const [retry, setRetry] = useState(3)
    return useQuery("annieusersurvey", async () => {
        const { data } = await axios.get(
            "/api/v2/annieusersurvey.php/",
            auth
        )
        return data}, {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount:true,
        retry: retry,
        onError: error => {
            if (error.response?.status === 401) {
                setRetry(0)
            }
        }
    })
}

export function GetUserBySurvey(surveyId) {
    return useQuery('annieusersurvey'+surveyId, async () => {
        const { data } = await axios.get(
            "/api/v2/annieusersurvey.php/?survey=" + surveyId,
            auth
        )
        return data})
}

export function PostUsersToAnnieUserSurvey() {
    return useMutation('annieusersurvey', userSurveyData => {
        const data = axios.post(
            "/api/v2/annieusersurvey.php/",
            userSurveyData,
            auth
        )
        return data
    })
}

// Does not exist?
export function GetSupportNeedUsersBySurvey(surveyId) {
    return useQuery("annieusersurvey", async () => {
        const { data } = await axios.get(
            "/api/v2/annieusersurvey.php/",
            auth
        )
        return data
    })
}

export function GetSupportContacts() {
    return useQuery("contacts", async () => {
        const { data } = await axios.get(
            "/api/v2/contact.php/",
            auth
        )
        return data
    })
}

export function GetSupportContactsWithId(surveyId) {
    return useQuery('contacts'+surveyId, async () => {
        const { data } = await axios.get(
            "/api/v2/contact.php/"+surveyId,
            auth
        )
        return data
    }, {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount:"always",
        cacheTime:0,
    })
}

export function GetCodes() {
    return useQuery("codes", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/",
            auth
        )
        return data
    })
}

export function GetCategories() {
    return useQuery("categories", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/category",
            auth
        )
        return data
    })
}

export function PostCodes() {
    return useMutation('codes', codesData => {
        const data = axios.post(
            "/api/v2/codes.php/",
            codesData,
            auth
        )
        return data
    })
}

export function GetContacts() {
    return useQuery("contacts", async () => {
        const { data } = await axios.get(
            "/api/v2/contact.php",
            auth
        )
        return data
    })
}

export async function archiveSurveyWithId(surveyId) {
    try {
        const response = await axios.get(
            "/api/v2/archive-survey-statistics.php?survey="+surveyId+"&archive=true",
            auth
        )
        return response
    } catch (error) {
        console.error(error)
        return error
    }
}

export function GetFollowUpConfig() {
    return useQuery("followupConfig", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/followup",
            auth
        )
        return data
    })
}

export function GetFollowUpConfigWithLang(lang) {
    return useQuery("GetFollowUpConfigWithLang"+lang, async () => {
        const { data } = await axios.get(
            "/api/v2/translation.php/sms/followupConfig/"+lang,
            auth
        )
        return data
    })
}

export function GetAppTranslations(language) {
    const lang = language ? "?language="+language : ""
    return useQuery("appTranslations"+lang, async () => {
        const { data } = await axios.get(
            "/api/v2/translation.php/admin"+lang,
            auth
        )
        return data
    })
}

export function GetGeneralTranslations(language) {
    const lang = language ? "?language="+language : ""
    return useQuery("generalTranslations"+lang, async () => {
        const { data } = await axios.get(
            "/api/v2/translation.php/general"+lang,
            auth
        )
        return data
    })
}

export function GetInstanceLanguage() {
    return useQuery("instanceLanguage", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/language",
            auth
        )
        return data
    })
}

export function GetLanguageOptions() {
    return useQuery("languageOptions", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/languages",
            auth
        )
        return data
    })
}

export function GetSupportRoles() {
    return useQuery("supportRoles", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/role",
            auth
        )
        return data
    })
}

export function GetUserAndRoleOfContact() {
    return useQuery("contactannieuser", async () => {
        const { data } = await axios.get(
            "/api/v2/contactannieuser.php/",
            auth
        )
        return data
    })
}

export function GetInstanceFollowupConfig() {
    return useQuery('instanceFollowupConfig', async () => {
        const {data} = await axios.get(
            "/api/v2/followuptemplates.php/",
            auth
        )
        return data
    })
}

export function GetSelectOptions() {
    return useQuery("selectables", async () => {
        const { data } = await axios.get(
            "/api/v2/selectables.php",
            auth
        )
        return data
    })
}

export const updateSurvey = async (updatedSurvey, surveyId) => {
    const response = await axios.post(
        "/api/v2/survey.php/" + surveyId,
        updatedSurvey,
        auth
    )
    return response.data;
}

export function GetSurveyTypes() {
    return useQuery("surveytype", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/surveytype",
            auth
        )
        return data
    })
}

export function GetRoleTranslationWithInstanceLang(role, lang, enabled = true) {
    return useQuery("roleTranslation"+role+lang, async () => {
        const { data } = await axios.get(
            `/api/v2/translation.php/general/role.${role}/${lang}`,
            auth
        )
        return data
    }, {
        enabled: enabled && lang !== null && role !== null
    })
}

export function PostTestSurvey() {
    return useMutation('postTestSurvey',testData => {
        const data = axios.post(
            "/api/v2/campaignpreview.php/",
            testData,
            auth
        )
        return data
    })
}

export function GetCopyOfTextWithInstanceLang(lang) {
    return useQuery("copyOfSurvey"+lang, async () => {
        const { data } = await axios.get(
            `/api/v2/translation.php/admin/copyOfSurvey/${lang}`,
            auth
        )
        return data
    })
}

export function GetDefaultErrorMessageWithSurveyLang(lang) {
    return useQuery("defaultErrorMessage"+lang, async () => {
        const { data } = await axios.get(
            `/api/v2/translation.php/admin/defaultErrorMessage/${lang}`,
            auth
        )
        return data
    })
}

export function GetOrTextWithSurveyLang(lang) {
    return useQuery("general"+lang, async () => {
        const { data } = await axios.get(
            `/api/v2/translation.php/general/or/${lang}`,
            auth
        )
        return data
    })
}

export function GetUseCases() {
    return useQuery("useCases", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/usecase",
            auth
        )
        return data
    })
}

export function GetCustomerSegment() {
    return useQuery("customerSegment", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/customersegment",
            auth
        )
        return data
    })
}